import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getApiUrl } from '../config/runtime-config';

// Types for Templates API Response
export interface TemplateReport {
  templateId: string;
  templateName: string;
  questionCount: number;
  confidenceScore: number;
  lastRunDate: string | null;
}

// Types for Questions API Response
export interface QuestionReport {
  id: string;
  name: string;
  dataType: string | null;
  confidenceScore: number;
  hasAnalysisData: boolean;
  prompts: string;
}

export interface QuestionsResponse {
  templateId: string;
  templateName: string;
  questions: QuestionReport[];
}

// Types for Question Details API Response
export interface LocationResult {
  instanceId: string;
  locationId: string;
  locationNumber: string;
  location: string;
  meetsQualityStandards: boolean;
  score: number;
  analysis: string;
  imageUrl: string | null;
  documentId: string;
}

export interface QuestionDetailsResponse {
  templateId: string;
  templateName: string;
  questionId: string;
  questionText: string;
  prompts: string;
  averageConfidenceScore: number;
  locationResults: LocationResult[];
}

@Injectable({
  providedIn: 'root'
})
export class AnalysisReportService {
  private readonly apiUrl = getApiUrl();

  constructor(private http: HttpClient) {}

  getTemplates(): Observable<TemplateReport[]> {
    return this.http.get<TemplateReport[]>(`${this.apiUrl}/api/AnalysisReport/templates`);
  }

  getQuestions(templateId: string): Observable<QuestionsResponse> {
    return this.http.get<QuestionsResponse>(`${this.apiUrl}/api/AnalysisReport/questions/${templateId}`);
  }

  getQuestionDetails(templateId: string, questionId: string): Observable<QuestionDetailsResponse> {
    return this.http.get<QuestionDetailsResponse>(`${this.apiUrl}/api/AnalysisReport/question/${templateId}/${questionId}`);
  }
}
